module.exports = __webpack_public_path__ + "static/img/core_value.1905f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/core_value.png
// module id = gGW+
// module chunks = 0